<template>
  <transition name="fade" v-if="showModal">
    <Modal @close="invertModalStatus">
      <div slot="content" class="tips">
        <div class="content-header">
          <div class="icon">
            <fa-icon icon="info-circle" />
          </div>
        </div>
        <p>
          マイクとカメラは<br />
          ページ上のボタンで切り替え可能です。
        </p>
        <div class="btn-wrapper">
          <button @click="invertModalStatus">接続</button>
        </div>
      </div>
    </Modal>
  </transition>
</template>

<script>
import Modal from "../elements/Modal"

export default {
  name: "Tips",
  components: {
    Modal
  },
  created() {
    this.checkFirstVisit()
  },
  data: function() {
    return {
      showModal: true
    }
  },
  methods: {
    invertModalStatus() {
      this.showModal = !this.showModal
    },
    checkFirstVisit() {
      // ToDo クッキー関連の処理は共通化 https://valeur.backlog.jp/view/YOSHIDA_VIRTUAL-134
      const slug = this.$route.params.slug
      const firstTimeFlg = document.cookie
        .split(";")
        .find(row => row.startsWith(slug))
        .split("=")[1]

      this.showModal = firstTimeFlg !== "true"
      document.cookie = `${slug}=true`
    }
  }
}
</script>
